export const BOOTSTRAP_NOTES = 'BOOTSTRAP_NOTES'
export const ADD_NOTE = 'ADD_NOTE'
export const UPDATE_NOTE = 'UPDATE_NOTE'
export const DELETE_NOTE = 'DELETE_NOTE'
